import React, { useState, useEffect, useMemo } from "react";
import { View, BackHandler, Keyboard, useWindowDimensions } from 'react-native';
import { NavigationProp, ParamListBase, useIsFocused, useNavigation, useRoute } from '@react-navigation/native';
import Popover from 'react-native-popover-view';
import { FormikValues, useFormik } from 'formik';
import * as Yup from 'yup';
import { addRouteData, ModifierData, ProductDetails, locationValue, modifierValue, optionRes, ProductFormValues, productPayload, variantValue, GetOneProductDetails, } from "../productModule";
import { getScreenPermission, useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { config } from "../../../../shared/environment";
import { appColors, appFonts, fontSize } from "../../../../themes/appTheme";
import { addProductCatalog, fullFillment, getAllBrandsNameForPosRedux, getAllCategoriesNameForPosRedux, getAllModfierSetRedux, getAllPosManualTaxRedux, getOnePosProductDetailsRedux, getPosVariantAttachments, getVariantCombinationRedux, updateProductCatalog } from "../../../../redux/slices/productSlice";
import { ZenButton, ZenLoader, ZenToast } from "zen-core-elements";
import { ItemTypeValue } from "zen-core-elements/src/elements/zenDropdown/dropdownPicker";
import ProductModifier from "./productModifer";
import CommonDialogBox from "../../../../shared/commonComponents/commonDialogBox";
import CommonHeader from "../../../../shared/commonComponents/commonHeader";
import ProductGeneral from "./productGeneral";
import ProductVariant from "./productVariant";
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import { CustomModal } from "../../../../shared/commonComponents/customModal";
import { ThemeConsumer, useTheme } from "@rneui/themed";
import { shallowEqual } from "react-redux";
import { useAppRoute } from "../../../../types/@react-navigation/navigation";
import { getAllPosCategoryData } from "../../../../redux/slices/categorySlice";
const AddEditProduct = () => {

    const { width } = useWindowDimensions()
    const { isWrite: isProductWrite } = useAppSelector(getScreenPermission("ProductStack"), shallowEqual)

    //Variable which is used to store storeId
    const storeId = config.storeId
    const isFocused = useIsFocused()
    const dispatch = useAppDispatch()
    //State variable to use createMaterialTopTabNavigator hook
    const TopTab = createMaterialTopTabNavigator();
    const locationData = useAppSelector(state => state?.common?.getStoreLocations?.value)
    // Variable which is used to perform navigation
    const navigation = useNavigation<NavigationProp<ParamListBase>>();

    // Variable to get the route params from productlist
    const route = useAppRoute("AddEditProduct");

    //Variable used to store the fetched product id
    const productId = route?.params?.productId

    // Variable which is used to store selected variant value
    const [selectedVar, setSelectedVar] = useState<number[]>([])

    // Variable which is used to store selected variant object
    const [selectedVarObj, setSelectedVarObj] = useState<{ label?: string, value: number }[]>([])

    // Variable which is used to store variant response
    const [varRes, setVarRes] = useState<optionRes['result']>([])

    // Variable which is used to store selected tax value
    const [selectedTax, setSelectedTax] = useState<number[]>([])

    // Variable which is used to store tax copy for reset
    const [taxCopy, setTaxCopy] = useState<number[]>([])

    // Variable which is used to store the variants response
    const [variants, setVariants] = useState<{ label: string, value: number }[]>([])

    // Variable which is used to store the upload status of the images
    const [imgUploading, setImgUploading] = useState(false)

    // Variable which is used to store other angle image urls
    const [multipleImages, setMultipleImages] = useState<{ imgKey: string, uploadCompleted: boolean, uploadLoader: boolean, id: number }[]>([]);

    const [varCombinations, setVariantCombinations] = useState<variantValue>({})

    // Variable used to hold category options data
    const [categoryOptions, setCategoryOptions] = useState<{ label: string, value: number }[]>([]);

    // Variable used to hold brand options data
    const [brandOptions, setBrandOptions] = useState<ItemTypeValue[]>([]);

    //State variable to store modifier data
    const [modifierData, setModifierData] = useState<ModifierData[]>([]);
    const [modiferDropdownData, setModiferDropdownData] = useState<ItemTypeValue[]>([])
    // Variable used to hold taxClass options data
    const [taxClassOptions, setTaxClassOptions] = useState<{ label: string, value: number, isEnabledAllProducts: boolean, isEnabled: boolean }[]>([]);

    // Variable used to hold location options data
    const [locationOptions, setLocationOptions] = useState<{ label: string, value: number }[]>([]);

    // Variable which is used to store the combinations with checked state
    const [checked, setChecked] = useState<{ [Key: string]: { id?: string, checked?: boolean } }[]>([])

    // Variable used to hold weight unit
    const [weightOptions, setWeightOptions] = useState<ItemTypeValue[]>([])

    // Variable used to hold dimension data
    const [dimensionOptions, setDimensionOptions] = useState<ItemTypeValue[]>([])

    //Variable which is used to Store the loading status
    const [isLoad, setIsLoad] = useState(true);

    //Variable which is used to Store the modValidation state
    const [modValidation, setModValidation] = useState(false)

    // Variable which is used to check duplicate product name
    const [isDuplicateValue, setIsDuplicateValue] = useState(false)

    // Variable which is used to set the duplicate name loader
    const [dupLoader, setDupLoader] = useState({ productName: false, sku: false });

    // Variable which is used to check duplicate SKU
    const [isDuplicateSku, setIsDuplicateSku] = useState(false)

    //Variable used to handle leave page dialog
    const [isLeavePopover, setIsLeavePopover] = useState(false)


    //Variable which is used to store button load
    const [saveLoad, setSaveLoad] = useState(false)

    // Variable which is used to hold multiTextArray values
    let multiTextArray: string[] = [];

    // Variable which is used to hold multi category value
    const [multiCategory, setMultiCategory] = useState<string[]>([])

    // Variable which is used to hold multi tax value
    const [multiTax, setMultiTax] = useState<string[]>()

    // Variable which is used to hold multi variants
    const [multiVariants, setMultiVariants] = useState<string[]>([])

    //Variable which is used to store local stock
    const [locArr, setLocArr] = useState<{
        id?: number
        stock: string,
        threshold: string,
        selectedLoc: number,
        isInfinite: boolean,
    }[]>([
        {
            stock: "",
            threshold: "",
            selectedLoc: -1,
            isInfinite: true,
        }
    ])

    // Variable used to delete main image
    const [delMain, setDelMain] = useState<{
        image?: string,
        fileName?: string,
        isDelete: boolean
    }[]>([])

    const [mainImage, setMainImage] = useState<ProductFormValues["featuredImage"][] | null>([])

    //Variable used to store the selected option object
    const [selectedModOptObj, setSelectedModOptObj] = useState<ModifierData[]>([])

    //Variable which is used to store default location
    const [defLoc, setDefLoc] = useState<number>()

    // Variable which is used to hold multi tax value
    const [defaultTax, setDefaultTax] = useState<number[]>([])

    // Variable used to hold the product for editing
    const [editProduct, setEditProduct] = useState<ProductDetails>()

    // Variable used to store remove variant id
    const [removeVarId, setRemoveVarId] = useState<number[]>([])

    // Variable used to store remove variant id from general
    const [rvarIds, setRvarIds] = useState<number[]>([])

    // Variable used to store fetched initially disabled defaults
    const [initDis, setInitDis] = useState<number[]>([])

    // Variable used to store single product vid
    const [singleVid, setSingleVid] = useState<number>()

    //Variable used to store fetched modifier details
    const [editMod, setEditMod] = useState<GetOneProductDetails["productDetails"]["productModifiers"]>([])
    //Variable used to store fetched modifier in update format
    const [modUpdate, setModUpdate] = useState<modifierValue[]>([])
    //Variable used to store initial modifier option values
    const [initialModifierOption, setInitialModifierOption] = useState<modifierValue[]>([])
    //Variable used to store fetched modifierid in update format
    const [modIdUpdate, setModIdUpdate] = useState<number[]>([])
    //Variable used to store the options sets
    const [optionsMod, setOptionsMod] = useState<{ id: number, label: string, value: number }[][]>([])


    // Variable used to store selected modifier ids
    const [modifierIds, setModifierIds] = useState<number[]>([])
    //Variable used to store the multiple modifiers from options
    const [multiOptions, setMultiOptions] = useState<string[]>([])

    // Variable used to maintain validation schema for inputs
    const baseSchema: Yup.ObjectSchema<{}> = Yup.object().shape({
        ProductName: Yup.string()
            .label('ProductName')
            .required('Product name is required.')
            .max(255, 'Product name should not exceed 255 characters.'),
        brand: Yup.string().nullable().label('brand'),
        categories: Yup.array().nullable().label('categories')
            .required('Category is required.'),
        featuredImage: Yup.object()
            .shape({
                imgKey: Yup.string().required("Image key is required"),
                uploadCompleted: Yup.boolean().oneOf([true], "Image must be uploaded"),
            })
            .label("featuredImage")
            .nullable()
            .notRequired(),

        additionalImages: Yup.array()
            .of(
                Yup.object().shape({
                    imgKey: Yup.string().required("Image key is required"),
                    uploadCompleted: Yup.boolean().oneOf([true], "Image must be uploaded"),
                })
            )
            .label("additionalImages")
            .nullable()
            .notRequired(),

        weightUnit: Yup
            .string()
            .label('weightUnit')
            .nullable(),
        dimensionUnit: Yup
            .string()
            .label('dimensionUnit')
            .nullable(),
        length: Yup
            .number()
            .label('length')
            .nullable()
            .typeError('Only numbers are allowed'),
        width: Yup
            .number()
            .label('width')
            .nullable()
            .typeError('Only numbers are allowed'),
        height: Yup
            .number()
            .label('height')
            .nullable()
            .typeError('Only numbers are allowed'),
        weight: Yup
            .number()
            .label('weight')
            .nullable()
            .typeError('Only numbers are allowed'),
        Sku: Yup.string()
            .matches(/^[a-zA-Z0-9._-]*$/, "Please enter valid input")
            .max(64, 'SKU exceeds the limits.'),
        Upc: Yup.string().nullable(),
        isMultiVariants: Yup.boolean(),
        sellingPrice: Yup.number()
            .when("isMultiVariants", (isMultiVariants) => {
                if (!isMultiVariants[0]) {
                    return Yup.number()
                        .label('sellingPrice')
                        .typeError('Selling price must be a number')
                        .transform((value, originalValue) => {
                            if (typeof originalValue === 'string' && originalValue.includes(" ")) {
                                return NaN;
                            }
                            return value;
                        })
                        .test(
                            "requiredValidation",
                            "Selling price is required",
                            (value) => (value || value == 0) ? true : false
                        )
                        .test(
                            'is-decimal',
                            'Please enter valid input',
                            (value, og) => {
                                const ogVal = og?.originalValue;
                                if (typeof ogVal === 'string' && ogVal.match(/^\d*\.+\d*$/)) {
                                    return /^\d+\.{1}\d{1,2}$/.test(ogVal);
                                }
                                return true;
                            },
                        )
                        .min(0.01, "Selling price must be greater than or equal to 0.01")
                        .max(1000000, 'Selling price should not exceed 10,00,000.')

                }
                else {
                    return Yup.number()
                }
            }),
        MRP: Yup.number()
            .typeError('MRP must be a number')
            .transform((value, originalValue) => {
                if (typeof originalValue === 'string' && originalValue.includes(" ")) {
                    return NaN;
                }
                return value;
            })
            .label('MRP')
            .max(1000000, 'MRP should not exceed 10,00,000.')
            .test(
                'is-decimal',
                'Please enter valid input',
                (value, og) => {
                    const ogVal = og?.originalValue;
                    if (typeof ogVal === 'string' && ogVal.match(/^\d*\.+\d*$/)) {
                        return /^\d+\.{1}\d{1,2}$/.test(ogVal);
                    }
                    return true;
                },
            )
            .when('sellingPrice', (sellingPrice, schema) =>
                schema.test(
                    'is-great',
                    "MRP should be greater than or equal to selling price.",
                    (value) => {
                        if (typeof value === 'undefined' || typeof sellingPrice[0] === 'undefined') return true;
                        return value >= sellingPrice[0];
                    }
                )
            ),

        costPrice: Yup.number()
            .when("isMultiVariants", (isMultiVariants) => {
                if (!isMultiVariants[0]) {
                    return Yup.number()
                        .typeError('Cost price must be a number')
                        .required("Cost price is required")
                        .transform((value, originalValue) => {
                            if (typeof originalValue === 'string' && originalValue.includes(" ")) {
                                return NaN;
                            }
                            return value;
                        })
                        .max(1000000, 'Cost price should not exceed 10,00,000')
                        .min(0.01, "Cost price must be greater than or equal to 0.01")
                        .label('costPrice')
                        .test(
                            'is-decimal',
                            'Please enter valid input',
                            (value, og) => {
                                const ogVal = og?.originalValue;
                                if (typeof ogVal === 'string' && ogVal.match(/^\d*\.+\d*$/)) {
                                    return /^\d+\.{1}\d{1,2}$/.test(ogVal);
                                }
                                return true;
                            },
                        )
                }
                else {
                    return Yup.number()
                }
            }),


        WholesalePrice: Yup.number()
            .typeError('Wholesale price must be a number')
            .label('WholesalePrice')
            .transform((value, originalValue) => {
                if (typeof originalValue === 'string' && originalValue.includes(" ")) {
                    return NaN;
                }
                return value;
            })
            .max(100000, 'WholeSale price exceeds limit')
            .min(0.01, "WholeSale price must be greater than or equal to 0.01")
            .test(
                'is-decimal',
                'Please enter valid input',
                (value, og) => {
                    const ogVal = og?.originalValue;
                    if (typeof ogVal === 'string' && ogVal.match(/^\d*\.+\d*$/)) {
                        return /^\d+\.{1}\d{1,2}$/.test(ogVal);
                    }
                    return true;
                },
            )
            .when('sellingPrice', (sellingPrice, schema) =>
                schema.test(
                    'is-less',
                    "MRP should be greater than or equal to selling price.",
                    (value) => {
                        if (typeof value === 'undefined' || typeof sellingPrice[0] === 'undefined') return true;
                        return value <= sellingPrice[0];
                    }
                )
            ),

        ShortDescription: Yup.string()
            .max(150, 'Short description should not exceed 150 characters.'),
        ProductUnitCount: Yup.number()
            .typeError('Product unit count must be a number')
            .required('Product unit count is required')
            .min(0.1, 'Product unit count should be greater than or equal to 0.1')
            .max(10000, 'Product unit count should be lesser than or equal to 10000')
            .test(
                'is-decimal',
                'Please enter valid input',
                (value, og) => {
                    const ogVal = og?.originalValue;
                    if (typeof ogVal === 'string' && ogVal.match(/^\d*\.+\d*$/)) {
                        return /^\d+\.{1}\d{1,2}$/.test(ogVal);
                    }
                    return true;
                },
            ),


        locArr: Yup.array().of(
            Yup.object().shape({
                selectedLoc: Yup.number()
                    .typeError('Location is required.')
                    .required('Location is required.'),
                isInfinite: Yup.boolean(),
                stock: Yup.number().when('isInfinite', (isInfinite) => {
                    if (!isInfinite[0]) {
                        return Yup.number()
                            .min(0, 'Limited stock should be greater than or equal to Zero')
                            .max(100000, 'Limited stock should not exceed 1,00,000')
                            .test('matches', 'Please enter valid input', (val, og) => {
                                return /^-1$|^\d+(\.\d{1,2})?$/.test(og.originalValue)
                            })
                            .required('Limited stock is required.')
                    }
                    else {
                        return Yup.number()
                    }
                }),
                threshold: Yup.number().when('isInfinite', (isInfinite) => {
                    if (!isInfinite[0]) {
                        return Yup.number()
                            .min(0, 'Low stock threshold value should be greater than Zero')
                            .max(100000, 'Low stock threshold value should not exceed 1,00,000.')
                            .test('matches', 'Low stock threshold is invalid', (val, og) => {
                                return /^-1$|^\d+(\.\d{1,2})?$/.test(og.originalValue)
                            })
                            .required('Low stock threshold value is required.')
                    }
                    else {
                        return Yup.number()
                    }
                })

            })
        ),
        varCombinations: Yup.mixed().when('isMultiVariants', (isMultiVariants, schema) => {
            if (isMultiVariants && isMultiVariants[0]) {
                // @ts-ignore
                return Yup.object().test('validate-each-variant', null, async function (value) {
                    if (!value || typeof value !== 'object') return true;

                    const errors: Record<string, any> = {};
                    let hasErrors = false;

                    for (const [key, val] of Object.entries(value)) {
                        try {
                            await variantSchema.validate(val, { abortEarly: false });
                        } catch (err: any) {
                            hasErrors = true;
                            errors[key] = {};
                            err.inner.forEach((e: any) => {
                                errors[key][e.path] = e.message;
                            });
                        }
                    }

                    if (hasErrors) {
                        return this.createError({ path: `${this.path}`, message: errors });
                    }

                    return true;
                });
            }

            return Yup.mixed().notRequired();
        }),



    })

    const variantSchema = Yup.object().shape({
        isSellOnline: Yup.boolean().required(),
        isSellPos: Yup.boolean().required(),
        isDefault: Yup.boolean().required(),
        removedVariantImagesUrl: Yup.array().of(Yup.object().shape({
            id: Yup.string()
        })),
        vid: Yup.number().nullable(),
        locArr: Yup.array().of(
            Yup.object().shape({
                selectedLoc: Yup.number().required('Location is required'),
                stock: Yup.number()
                    .min(0)
                    .max(100000)
                    .required()
                    .test('matches', 'Stock must be valid', (val, ctx) =>
                        /^-1$|^\d+(\.\d{1,2})?$/.test(ctx.originalValue)
                    ),
                threshold: Yup.number()
                    .min(0)
                    .max(100000)
                    .required()
                    .test('matches', 'Threshold must be valid', (val, ctx) =>
                        /^-1$|^\d+(\.\d{1,2})?$/.test(ctx.originalValue)
                    ),
            })
        ),
        weightOpen: Yup.boolean().required(),
        dimensionOpen: Yup.boolean().required(),
        selectedWunit: Yup.string().nullable(),
        selectedDunit: Yup.string().nullable(),
        width: Yup.string().nullable(),
        weight: Yup.string().nullable(),
        height: Yup.string().nullable(),
        length: Yup.string().nullable(),
        SKU: Yup.string()
            .matches(/^[a-zA-Z0-9._-]*$/, 'Invalid SKU')
            .max(64),
        UPC: Yup.string().nullable(),
        taxCode: Yup.string().nullable(),
        sellingPrice: Yup.number()
            .when("isMultiVariants", (isMultiVariants) => {
                if (!isMultiVariants[0]) {
                    return Yup.number()
                        .label('sellingPrice')
                        .typeError('Selling price must be a number')
                        .transform((value, originalValue) => {
                            if (typeof originalValue === 'string' && originalValue.includes(" ")) {
                                return NaN;
                            }
                            return value;
                        })
                        .test(
                            "requiredValidation",
                            "Selling price is required",
                            (value) => (value || value == 0) ? true : false
                        )
                        .test(
                            'is-decimal',
                            'Please enter valid input',
                            (value, og) => {
                                const ogVal = og?.originalValue;
                                if (typeof ogVal === 'string' && ogVal.match(/^\d*\.+\d*$/)) {
                                    return /^\d+\.{1}\d{1,2}$/.test(ogVal);
                                }
                                return true;
                            },
                        )
                        .min(0.01, "Selling price must be greater than or equal to 0.01")
                        .max(1000000, 'Selling price should not exceed 10,00,000.')

                }
                else {
                    return Yup.number()
                }
            }),
        MRP: Yup.number()
            .typeError('MRP must be a number')
            .transform((value, originalValue) => {
                if (typeof originalValue === 'string' && originalValue.includes(" ")) {
                    return NaN;
                }
                return value;
            })
            .label('MRP')
            .max(1000000, 'MRP should not exceed 10,00,000.')
            .test(
                'is-decimal',
                'Please enter valid input',
                (value, og) => {
                    const ogVal = og?.originalValue;
                    if (typeof ogVal === 'string' && ogVal.match(/^\d*\.+\d*$/)) {
                        return /^\d+\.{1}\d{1,2}$/.test(ogVal);
                    }
                    return true;
                },
            )
            .when('sellingPrice', (sellingPrice, schema) =>
                schema.test(
                    'is-great',
                    "MRP should be greater than or equal to selling price.",
                    (value) => {
                        if (typeof value === 'undefined' || typeof sellingPrice[0] === 'undefined') return true;
                        return value >= sellingPrice[0];
                    }
                )
            ),
        costPrice: Yup.number()
            .typeError('Cost price must be a number')
            .required("Cost price is required")
            .transform((value, originalValue) => {
                if (typeof originalValue === 'string' && originalValue.includes(" ")) {
                    return NaN;
                }
                return value;
            })
            .max(1000000, 'Cost price should not exceed 10,00,000')
            .min(0.01, "Cost price must be greater than or equal to 0.01")
            .label('costPrice')
            .test(
                'is-decimal',
                'Please enter valid input',
                (value, og) => {
                    const ogVal = og?.originalValue;
                    if (typeof ogVal === 'string' && ogVal.match(/^\d*\.+\d*$/)) {
                        return /^\d+\.{1}\d{1,2}$/.test(ogVal);
                    }
                    return true;
                },
            ),
        WholesalePrice: Yup.number()
            .typeError('Wholesale price must be a number')
            .label('WholesalePrice')
            .transform((value, originalValue) => {
                if (typeof originalValue === 'string' && originalValue.includes(" ")) {
                    return NaN;
                }
                return value;
            })
            .max(100000, 'WholeSale price exceeds limit')
            .min(0.01, "WholeSale price must be greater than or equal to 0.01")
            .test(
                'is-decimal',
                'Please enter valid input',
                (value, og) => {
                    const ogVal = og?.originalValue;
                    if (typeof ogVal === 'string' && ogVal.match(/^\d*\.+\d*$/)) {
                        return /^\d+\.{1}\d{1,2}$/.test(ogVal);
                    }
                    return true;
                },
            )
            .when('sellingPrice', (sellingPrice, schema) =>
                schema.test(
                    'is-less',
                    "MRP should be greater than or equal to selling price.",
                    (value) => {
                        if (typeof value === 'undefined' || typeof sellingPrice[0] === 'undefined') return true;
                        return value <= sellingPrice[0];
                    }
                )
            ),
        SquareId: Yup.string().nullable(),
        CustomLabel: Yup.string().nullable(),
        valueId: Yup.array().of(Yup.number()).required(),
        varImages: Yup.array().of(
            Yup.object().shape({
                imgKey: Yup.string().required(),
                uploadCompleted: Yup.boolean().oneOf([true], 'Image must be uploaded'),
            })
        ).nullable(),
        variantAvailability: Yup.boolean().required(),
    });

    const getSelectedCategoryIds = useMemo(() => {
        if (!editProduct?.productCategories) return null;
        return [
            ...new Set(
                editProduct.productCategories.map(product => product?.categoryId),
            ),
        ];
    }, [editProduct?.productCategories]);

    // Variable which is used for formik
    const formik = useFormik<ProductFormValues>({
        enableReinitialize: true,
        validateOnMount: true,
        validateOnBlur: true,
        validateOnChange: true,
        initialValues: {
            ProductName: editProduct?.name ? editProduct?.name : "",
            brand: editProduct?.brandId ? editProduct?.brandId : null,
            categories: editProduct?.productCategories ? getSelectedCategoryIds : null,
            weightUnit: editProduct?.weightUnitId ? editProduct?.weightUnitId : null,
            isTaxable: editProduct?.isTaxable ? editProduct?.isTaxable : false,
            taxClasses: selectedTax ? selectedTax : [],
            featuredImage: editProduct?.featuredImage ? { imgKey: editProduct?.featuredImage, edit: true } : null,
            additionalImages: multipleImages?.length ? multipleImages : [],
            selectedVariants: selectedVar ?? [],
            dimensionUnit: "",
            sellOnline: false,
            width: '',
            weight: '',
            height: '',
            length: '',
            sellPos: true,
            ShortDescription: editProduct?.shortDescription ? editProduct?.shortDescription : "",
            ProductUnitCount: editProduct?.variantCombinationDetails[0]?.weightCount ? editProduct?.variantCombinationDetails[0]?.weightCount : '',
            Sku: (!editProduct?.isVariants) ? (editProduct?.variantCombinationDetails[0]?.sku ? editProduct?.variantCombinationDetails[0]?.sku : '') : '',
            Upc: (!editProduct?.isVariants) ? (editProduct?.variantCombinationDetails[0]?.upc ? editProduct?.variantCombinationDetails[0]?.upc : '') : '',

            sellingPrice: (!editProduct?.isVariants) ? (editProduct?.variantCombinationDetails[0]?.price ? editProduct?.variantCombinationDetails[0]?.price : '') : '',
            WholesalePrice: (!editProduct?.isVariants) ? (editProduct?.variantCombinationDetails[0]?.wholeSalePrice ? editProduct?.variantCombinationDetails[0]?.wholeSalePrice : '') : '',
            MRP: (!editProduct?.isVariants) ? (editProduct?.variantCombinationDetails[0]?.costComparePrice ? editProduct?.variantCombinationDetails[0]?.costComparePrice : '') : '',
            costPrice: (!editProduct?.isVariants) ? (editProduct?.variantCombinationDetails[0]?.cost ? editProduct?.variantCombinationDetails[0]?.cost : '') : '',
            isMultiVariants: editProduct?.isVariants ? editProduct?.isVariants : false,
            isAvailable: productId ? (editProduct?.productAvailability ? editProduct?.productAvailability : false) : true,

            isReturnable: editProduct?.isReturnable ? editProduct?.isReturnable : false,
            productType: editProduct?.isVeg ? "Vegetarian" : (!editProduct?.isVeg ? "Non Vegetarian" : "Others"),
            ChooseTaxClass: '',
            square: (!editProduct?.isVariants) ? (editProduct?.variantCombinationDetails[0]?.squarePosUuid ? editProduct?.variantCombinationDetails[0]?.squarePosUuid : '') : '',
            taxCode: (!editProduct?.isVariants) ? (editProduct?.variantCombinationDetails[0]?.taxCode ? editProduct?.variantCombinationDetails[0]?.taxCode : (productId ? "" : "P000000")) : '',
            locArr: locArr,
            removedVariantImagesUrl: [],
            varCombinations: varCombinations ? varCombinations : {},
            modifierIds: modifierIds ?? [],
            modifierOption: initialModifierOption
        },
        onSubmit: values => {
            Keyboard.dismiss();
            if (productId) {
                handleEditProduct(values)
            }
            else {
                handleAddProduct(values)
            }
        },
        validationSchema: baseSchema
    })

    //Function to make all the service calls
    const fetchOptions = () => {
        let fetchedOpt: optionRes['result']
        let variant: { label: string, value: number }[] = []
        let categories: { label: string, value: number }[] = []
        let taxClass: { label: string, value: number, isEnabledAllProducts: boolean, isEnabled: boolean }[] = []
        let tempTax: number[] = []
        dispatch(getAllCategoriesNameForPosRedux()).unwrap().then((res) => {
            for (let i = 0; i < res?.category?.length; i++) {
                categories.push({ label: res?.category?.[i]?.name, value: res?.category?.[i]?.id })
            }
            setCategoryOptions(categories)
            dispatch(getAllBrandsNameForPosRedux()).unwrap().then((res) => {
                let brands: { label: string, value: number }[] = []
                for (let i = 0; i < res?.brand?.length; i++) {
                    brands.push({ label: res?.brand[i].name, value: res?.brand[i].id })
                }
                setBrandOptions(brands)
                dispatch(getAllPosManualTaxRedux()).unwrap().then((res) => {
                    let tempMulti: string[] = []
                    for (let i = 0; i < res["taxCategory"]?.rows?.length; i++) {
                        taxClass.push({ label: res["taxCategory"].rows[i].name as string, value: res["taxCategory"].rows[i].id as number, isEnabledAllProducts: res["taxCategory"].rows[i].isEnabledAllProducts, isEnabled: res["taxCategory"]?.rows[i]?.isEnabled })
                        if (res["taxCategory"].rows[i].isEnabledAllProducts) {
                            tempTax.push(res["taxCategory"].rows[i].id as number)
                            tempMulti.push(res["taxCategory"].rows[i].name as string)
                        }
                    }
                    setTaxClassOptions(taxClass)
                    setSelectedTax(tempTax)
                    setMultiTax(tempMulti)
                    setDefaultTax([...tempTax])
                    let location = []
                    for (let i = 0; i < locationData?.length; i++) {
                        if (locationData[i].isDefault) {
                            setDefLoc(locationData[i]?.id)
                            setLocArr(prev => {
                                return [{ ...prev[0], selectedLoc: locationData[i]?.id }]
                            })
                        }

                        location.push({ label: locationData[i].locationName, value: locationData[i].id })
                    }
                    setLocationOptions(location)
                    dispatch(getVariantCombinationRedux()).unwrap().then((res) => {
                        setVarRes(res.result)
                        fetchedOpt = res?.result
                        let varData = [...res.result]?.sort((a, b) => a?.name?.localeCompare(b?.name))
                        for (let i = 0; i < varData?.length; i++) {
                            variant.push({ label: varData[i].name, value: varData[i].id })
                        }
                        setVariants(variant)
                        dispatch(fullFillment()).unwrap().then((res) => {
                            if (res && res['unitData']) {
                                let weights: { value: number, label: string }[] = []
                                let lengths: { value: number, label: string }[] = []
                                res['unitData']?.map((data) => {
                                    if (data.code === 'MASS') {
                                        data.units.map((weight) => {
                                            weights.push({ "value": weight.id, "label": weight.abbrevation })
                                        })
                                    }
                                    if (data.code === 'LENGTH') {
                                        data.units.map((length) => {
                                            lengths.push({ "value": length.id, "label": length.abbrevation })
                                        })
                                    }
                                });
                                setWeightOptions(weights)
                                setDimensionOptions(lengths)


                                dispatch(getAllModfierSetRedux()).unwrap()
                                    .then(modifierResponse => {
                                        setModifierData(modifierResponse?.result?.rows);

                                        const tempArray: ItemTypeValue[] =
                                            modifierResponse?.result?.rows?.map(item => ({
                                                ...item,
                                                label: item?.modifierName,
                                                value: item?.id,
                                                defaultOpen: false
                                            })) ?? [];

                                        setModiferDropdownData(tempArray);

                                        if (productId) {
                                            editProductPatch(fetchedOpt, variant, tempTax, taxClass, categories, (editModVal) => {
                                                const editArray: ModifierData[] = [];
                                                const modIdArray: number[] = [];

                                                modifierResponse?.result?.rows?.forEach(item => {
                                                    if (editModVal.find(ele => ele.modifierId === item.id)) {
                                                        editArray.push({
                                                            ...item,
                                                            label: item?.modifierName,
                                                            value: item?.id,
                                                            defaultOpen: false
                                                        });
                                                        modIdArray.push(item?.id);
                                                    }
                                                });

                                                if (editArray.length > 0) {
                                                    setSelectedModOptObj(editArray);
                                                    setModifierIds(modIdArray);

                                                    const tempArr: string[] = tempArray
                                                        .filter(item => modIdArray.includes(item?.value as number))
                                                        .map(item => item.label as string)
                                                        .filter((label, index, self) => self.indexOf(label) === index);

                                                    setMultiOptions(tempArr);

                                                    const initialModOptions: modifierValue[] = [];
                                                    editArray.forEach(item => {
                                                        const editIndex = editModVal.findIndex(ele => ele.modifierId === item.id);
                                                        if (editIndex !== -1) {
                                                            initialModOptions.push({
                                                                storeId: storeId,
                                                                modifierName: item?.modifierName,
                                                                defaultOptionsId: editModVal[editIndex]?.defaultOptionsId ?? null,
                                                                modifierId: item?.id,
                                                                minModifiers: editModVal[editIndex]?.minModifiers ?? 0,
                                                                maxModifiers: editModVal[editIndex]?.maxModifiers ?? 0
                                                            });
                                                        }
                                                    });
                                                    setInitialModifierOption(initialModOptions);
                                                } else {
                                                    setInitialModifierOption([]);
                                                }
                                            });
                                        } else {
                                            setIsLoad(false);
                                        }

                                    }).catch((err) => {
                                        console.log("err in get modifier set data", err)
                                        if (err && err.response && err.response.data) {
                                            ZenToast({ message: err.response.data, type: "error" })
                                        } else if (err && err.message) {
                                            ZenToast({ message: err?.message, type: "error" })
                                        }
                                    })



                            }
                        }).catch((err) => {
                            console.log('err in get Measurement units', err)
                            if (err && err.response && err.response.data) {
                                ZenToast({ message: err?.response?.data, type: "error" })
                            } else if (err && err.message) {
                                ZenToast({ message: err?.message, type: "error" })
                            }
                        })
                    }).catch((err) => {
                        console.log('err in get variantoptions', err)
                        if (err && err.response && err.response.data) {
                            ZenToast({ message: err?.response?.data, type: "error" })
                        } else if (err && err.message) {
                            ZenToast({ message: err?.message, type: "error" })
                        }
                    })

                }).catch((err) => {
                    console.log('err in get all manual taxes', err)
                    if (err && err.response && err.response.data) {
                        ZenToast({ message: err?.response?.data, type: "error" })
                    } else if (err && err.message) {
                        ZenToast({ message: err?.message, type: "error" })
                    }
                })
            }).catch((err) => {
                console.log('err in get all brands', err)
                if (err && err.response && err.response.data) {
                    ZenToast({ message: err?.response?.data, type: "error" })
                } else if (err && err.message) {
                    ZenToast({ message: err?.message, type: "error" })
                }
            })
        }).catch((err) => {
            console.log('err in get all category', err)
            if (err && err.response && err.response.data) {
                ZenToast({ message: err?.response?.data, type: "error" })
            } else if (err && err.message) {
                ZenToast({ message: err?.message, type: "error" })
            }
        })
    }


    //Function to get all the variant combinations
    function getCombn(arr: { id: number | string, label: string }[][]) {
        let res = arr[0], i, j, k;
        for (i = 1; i < arr.length; i++) {
            let temp = [], sec = arr[i]
            for (j = 0; j < res.length; j++) {
                for (k = 0; k < sec.length; k++) {
                    temp.push({ "id": res[j].id + "," + sec[k].id, "label": (res[j].label + "," + sec[k].label)?.trim() })
                }
            }
            res = temp;
        }
        return res
    }



    const getFileExtension = (fileName: string | undefined): string | null => {
        return fileName ? fileName.split('.').pop() ?? null : null;
    };
    console.log(formik.errors);

    //Function used to add Product
    const handleAddProduct = (values: FormikValues) => {
        setSaveLoad(true)
        let variants = []
        let locationWiseStock: locationValue[] = []
        let productTaxMappings: { taxCategoryId?: number, isEnabled?: boolean, isEnabledAllProducts?: boolean }[] = []
        let varImagesArr: { fileName?: string, image?: string, isImageStore?: boolean }[] = []

        //Update variant array depending upon multi/single
        if (values.isMultiVariants) {
            Object.keys(formik?.values?.varCombinations)?.map((item, index) => {
                varImagesArr = []
                formik?.values?.varCombinations?.[item]?.locArr?.map((loc) => {
                    locationWiseStock.push({
                        "id": null,
                        "storeId": storeId,
                        "inventoryLocationId": loc.selectedLoc,
                        "stockLimit": (loc.stock == "-1") ? 2 : 1,
                        "lowStockThresholdValue": (loc.threshold == "-1") ? null : (loc.threshold ? loc.threshold : null),
                        "stock": loc.stock,
                    })
                })
                if (formik?.values?.varCombinations?.[item]?.varImages && formik?.values?.varCombinations?.[item]?.varImages?.length > 0) {
                    formik?.values?.varCombinations?.[item]?.varImages?.map((img, index) => {
                        if (img?.imgKey) {
                            let temp: { fileName?: string, image?: string, isImageStore?: boolean, sortOrder?: number } = {}
                            temp.fileName = img?.imgKey?.split('/').pop()
                            temp.image = img?.imgKey
                            temp.isImageStore = true
                            temp.sortOrder = index + 1
                            varImagesArr.push(temp)
                        }
                    })
                }
                variants.push({
                    "variantAttachments": formik?.values?.varCombinations[item]?.varImages?.length != 0 ? varImagesArr : [],
                    "removedVariantImagesUrl": [],
                    "optionValuesId": formik?.values?.varCombinations[item].valueId,
                    "variantName": item,
                    "variantCombinationData": {
                        "variantName": item,
                        "combinationName": formik?.values?.varCombinations[item]?.valueId?.sort().toString(),
                        // "skuId": null,
                        "sku": formik?.values?.varCombinations[item].SKU ? formik?.values?.varCombinations[item].SKU : null,
                        "squarePosUuid": formik?.values?.varCombinations[item].SquareId ? formik?.values?.varCombinations[item].SquareId : null,
                        "cost": formik?.values?.varCombinations[item].costPrice ? formik?.values?.varCombinations[item].costPrice : null,
                        "customLabel": formik?.values?.varCombinations[item].CustomLabel ? formik?.values?.varCombinations[item].CustomLabel : values.ProductName + "-" + item,
                        "upc": formik?.values?.varCombinations[item].UPC ? formik?.values?.varCombinations[item].UPC : null,
                        "measurementUnitId": formik?.values?.varCombinations[item].selectedDunit?.length != 0 ? parseInt(formik?.values?.varCombinations[item].selectedDunit as string) : null,
                        "weight": formik?.values?.varCombinations[item].weight ? formik?.values?.varCombinations[item].weight : null,
                        "weightCount": values.ProductUnitCount ? String(values.ProductUnitCount) : null,
                        "height": formik?.values?.varCombinations[item].height ? formik?.values?.varCombinations[item].height : null,
                        "width": formik?.values?.varCombinations[item].width ? formik?.values?.varCombinations[item].width : null,
                        "length": formik?.values?.varCombinations[item].length ? formik?.values?.varCombinations[item].length : null,
                        "locationWiseStock": locationWiseStock,
                        "costComparePrice": formik?.values?.varCombinations[item].MRP ? formik?.values?.varCombinations[item].MRP : null,
                        "price": formik?.values?.varCombinations[item].sellingPrice ? String(formik?.values?.varCombinations[item].sellingPrice) : null,
                        "wholeSalePrice": formik?.values?.varCombinations[item].WholesalePrice ? formik?.values?.varCombinations[item].WholesalePrice : null,
                        "isDefault": formik?.values?.varCombinations[item]?.isDefault,
                        "isPos": formik?.values?.varCombinations[item]?.isSellPos,

                        "variantAvailability": formik?.values?.varCombinations[item]?.variantAvailability,
                        "taxCode": formik?.values?.varCombinations[item]?.taxCode ? formik?.values?.varCombinations[item]?.taxCode : null
                    }
                })
                locationWiseStock = []
            })
        }
        else if (!values.isMultiVariants) {
            formik?.values?.locArr.map((loc) => {
                locationWiseStock.push({
                    "id": null,
                    "storeId": storeId,
                    "inventoryLocationId": loc.selectedLoc,
                    "stockLimit": (loc.stock == "-1") ? 2 : 1,
                    "lowStockThresholdValue": (loc.threshold == "-1") ? null : (loc.threshold ? loc.threshold : null),
                    "stock": loc.stock,
                })
            })
            variants.push({
                "variantAttachments": [],
                "removedVariantImagesUrl": [],
                "variantName": values.ProductName,
                "variantCombinationData": {
                    "variantName": values.ProductName,
                    "combinationName": values.ProductName ?? '',
                    "customLabel": values.ProductName ?? '',
                    "variantAvailability": true,
                    "sku": values.Sku ? values.Sku : null,
                    "squarePosUuid": values.square ? values.square : null,
                    "upc": values.Upc ? values.Upc : null,
                    "costComparePrice": values.MRP ? values.MRP : null,
                    "cost": values.costPrice ? values.costPrice : null,
                    "measurementUnitId": formik?.values?.varCombinations[values.ProductName]?.selectedDunit?.length != 0 ? parseInt(formik?.values?.varCombinations[values.ProductName].selectedDunit as string) : null,
                    "weight": formik?.values?.varCombinations[values.ProductName].weight ? formik?.values?.varCombinations[values.ProductName].weight : null,
                    "weightCount": values.ProductUnitCount ? String(values.ProductUnitCount) : null,
                    "height": formik?.values?.varCombinations[values.ProductName].height ? formik?.values?.varCombinations[values.ProductName].height : null,
                    "width": formik?.values?.varCombinations[values.ProductName].width ? formik?.values?.varCombinations[values.ProductName].width : null,
                    "length": formik?.values?.varCombinations[values.ProductName].length ? formik?.values?.varCombinations[values.ProductName].length : null,
                    "price": values.sellingPrice ? String(values.sellingPrice) : null,
                    "wholeSalePrice": values.WholesalePrice ? values.WholesalePrice : null,
                    "locationWiseStock": locationWiseStock,
                    "isDefault": true,
                    "isPos": values?.sellPos,
                    "taxCode": values?.taxCode ? values?.taxCode : null
                }
            })
            locationWiseStock = []
        }

        //Update Tax options selected
        formik.values.taxClasses.map((id) => {
            taxClassOptions.map((tax) => {
                if (id == tax.value) {
                    if (!tax.isEnabledAllProducts) {
                        productTaxMappings.push(
                            {
                                "taxCategoryId": id,
                                "isEnabled": true,
                                "isEnabledAllProducts": tax.isEnabledAllProducts
                            }
                        )
                    }
                }
            })
        })
        let found = false
        defaultTax.map((defId) => {
            found = false
            formik.values.taxClasses.map((selId) => {
                if (selId == defId) {
                    found = true
                }
            })
            if (!found) {
                productTaxMappings.push(
                    {
                        "taxCategoryId": defId,
                        "isEnabled": false,
                        "isEnabledAllProducts": true
                    }
                )
            }
        })

        //Final request parameter
        const data: productPayload = {
            general: {
                attachments: [
                    {
                        name: "Main Images",
                        attachmentData: formik?.values?.featuredImage?.imgKey ? [
                            formik?.values?.featuredImage?.edit ? {
                                "image": formik?.values?.featuredImage?.imgKey,
                                "fileName": formik?.values?.featuredImage?.imgKey?.split('/').pop()
                            } : {
                                fileName: formik?.values?.featuredImage?.imgKey?.split('/').pop(),
                                image: formik?.values?.featuredImage?.imgKey,
                                isImageStore: true,
                                // ext: getFileExtension(formik?.values?.featuredImage?.imgKey),
                            },
                        ] : [],
                    },
                    {
                        name: "Multiple Images",
                        attachmentCategoriesName: "Products",
                        attachmentData: formik?.values?.additionalImages?.map((additionalImage, index) => ({
                            fileName: additionalImage?.imgKey,
                            image: additionalImage?.imgKey,
                            isImageStore: true,
                            sortOrder: index + 1,
                            // ext: getFileExtension(additionalImage?.imgKey),
                        })) ?? [],
                    },
                    {
                        name: "",
                        attachmentData: []
                    }
                ],
                name: values.ProductName,
                "medium": "POS",
                relatedCategoryId: formik.values.categories,
                ...(values.ShortDescription && { shortDescription: values.ShortDescription }),
                ...(formik?.values.brand && { brandId: formik?.values.brand }),
                taxTypeId: formik.values.isTaxable ? 1 : 3,
                ...(formik.values.categories && { relatedCategoryId: formik.values.categories }),
                description: null,
                isVariants: values.isMultiVariants ? values.isMultiVariants : false,
                isVeg:
                    values.productType == "Vegetarian"
                        ? true
                        : values.productType == "Non Vegetarian"
                            ? false
                            : null,
                productAvailability: values.isAvailable,
                ...(values.ProductUnitCount && { weightCount: values.ProductUnitCount }),
                weightUnitId: formik.values.weightUnit ? parseInt(formik.values.weightUnit as string) : null,
                isReturnable: values.isReturnable,
                hasModifiers: formik.values.modifierOption?.length > 0 ? true : false,
                ...(formik.values.isTaxable && formik.values.taxClasses.length != 0 && {
                    taxCategoryId: formik.values.taxClasses
                })
            },
            ...(formik.values.isTaxable && { isTaxable: true }),
            ...(formik.values.isTaxable && productTaxMappings.length > 0 && {
                productTaxMappings: productTaxMappings
            }),
            variants: {
                storeId: storeId,
                ...(values.isMultiVariants && { optionIds: formik?.values?.selectedVariants }),
                variants: variants,
                ...(formik.values.modifierIds?.length > 0 && { modifierIds: formik.values.modifierIds }),
                ...(formik.values.modifierOption?.length > 0 && { modifierOption: formik.values.modifierOption })
            },
            productId: productId ?? null
        };

        const formData = new FormData();
        console.log(JSON.stringify(data, undefined, 4));

        formData.append("data", JSON.stringify(data));
        dispatch(addProductCatalog({ data: formData, storeId: config.storeId })).unwrap().then((res) => {
            if (res?.success) {
                setSaveLoad(false)
                ZenToast({ message: res?.planExceed ?? res?.message, type: res?.planExceed ? "error" : "success" })

                navigation.goBack()
            }
        }).catch((err) => {
            setSaveLoad(false)
            ZenToast({ message: err?.response?.isOptionDeleted ? 'The selected variant combination does not exist, Kindly try again.' : "Error in adding product", type: "error" })
        })
    }

    //Function to patch fetched details
    const editProductPatch = (fetchedOpt: optionRes['result'], variant: { label: string, value: number }[], initialTax: number[], taxClassOptions: { label: string, value: number, isEnabledAllProducts: boolean, isEnabled: boolean }[], fetchedCat: { label: string, value: number }[], onEditModSet?: (editModVal: ProductDetails["productModifiers"]) => void) => {
        dispatch(getOnePosProductDetailsRedux({ storeId, id: Number(productId) })).unwrap()
            .then((res) => {
                // General section
                setEditProduct({ ...res.productDetails })
                if (res?.productDetails?.featuredImage) {
                    setMainImage([{ imgKey: res?.productDetails?.featuredImage, edit: true }])
                }
                setEditMod(res?.productDetails?.productModifiers)
                onEditModSet?.(res?.productDetails?.productModifiers)
                let modParam: modifierValue[] = []
                let modParamIds: number[] = []
                //for Modifiers
                setModUpdate(modParam)
                setModIdUpdate(modParamIds)
                let tempArray: string[] = [];
                multiTextArray = []
                res?.productDetails?.productCategories?.find((value) => {
                    fetchedCat?.map((category) => {
                        if (category.value == value?.categoryId) {
                            multiTextArray?.push(category?.label);
                            tempArray = multiTextArray?.filter(
                                (item, i, newArray) =>
                                    newArray.indexOf(item) === i,
                            );
                        }
                    })
                });
                setMultiCategory([...tempArray]?.sort((a, b) => a?.localeCompare(b)));

                //Pricing Section
                if (res?.productDetails?.isTaxable) {
                    let defFalse: number[] = []
                    res?.productDetails?.productTaxMappings?.map((taxmap) => {
                        defFalse.push(taxmap.taxCategoryId)
                    })
                    setInitDis(defFalse)
                    res?.productDetails?.productTaxMappings?.map((taxmap) => {
                        initialTax.map((def, index) => {
                            if (def == taxmap.taxCategoryId) {
                                initialTax.splice(index, 1)
                            }
                        })
                    })
                    let taxIds = [...initialTax]
                    res?.productDetails?.productTaxMappings?.map((tax) => {
                        if (!taxIds.find(item => item === tax.taxCategoryId) && tax.isEnabled) {
                            taxIds.push(tax.taxCategoryId)
                        }
                    })
                    setSelectedTax(taxIds)
                    setTaxCopy(taxIds)
                    multiTextArray = []
                    taxClassOptions?.find((items) => {
                        taxIds?.find((value) => {
                            if (items.value === value) {
                                multiTextArray.push(items?.label);
                                tempArray = multiTextArray?.filter(
                                    (item, i, newArray) =>
                                        newArray.indexOf(item) === i,
                                );
                            }
                            setMultiTax(tempArray);
                        });
                    });
                }


                if (!res?.productDetails?.isVariants) {
                    let temp = res?.productDetails?.variantCombinationDetails[0]
                    let locArr: {
                        id: number,
                        stock: string,
                        threshold: string,
                        selectedLoc: number,
                        isInfinite: boolean,
                    }[] = []
                    temp?.multiLocationVariantStocks?.map((loc) => {
                        locArr.push({
                            id: loc?.id,
                            stock: JSON.stringify(loc?.stock),
                            selectedLoc: loc?.inventoryLocationId!,
                            threshold: loc?.lowStockThresholdValue ? JSON.stringify(loc?.lowStockThresholdValue) : "",
                            isInfinite: (loc?.stock == -1) ? true : false
                        })
                    })
                    setLocArr(locArr)
                    setSingleVid(temp?.id)
                    const newArr: variantValue = {};
                    newArr[res?.productDetails?.name] = {
                        isDefault: false,
                        isSellOnline: false,
                        isSellPos: temp?.isPos!,
                        vid: temp?.id,
                        selectedWunit: res?.productDetails?.weightUnitId ? String(res?.productDetails?.weightUnitId) : "",
                        selectedDunit: temp?.measurementUnitId ? String(temp?.measurementUnitId) : "",
                        width: temp?.width ? String(temp?.width) : '',
                        weight: temp?.weight ? String(temp?.weight) : '',
                        height: temp?.height ? String(temp?.height) : '',
                        length: temp?.length ? String(temp?.length) : '',
                        weightCount: temp?.weightCount ? temp?.weightCount : '',
                        weightOpen: false,
                        dimensionOpen: false,
                    };
                    setVariantCombinations(newArr);
                }


                // For attachment
                let variantId = res?.productDetails?.variantCombinationDetails?.map(i => i?.id)
                dispatch(getPosVariantAttachments({ productId: Number(productId), variantIds: JSON.stringify(variantId) })).unwrap()
                    .then((attRes) => {
                        let multi: { imgKey: string, uploadCompleted: boolean, id: number, uploadLoader: boolean }[] = []
                        if (attRes && attRes.productAttachments?.length > 0) {
                            if (!res?.productDetails?.isVariants) {
                                const allImages: { imgKey: string, uploadCompleted: boolean, uploadLoader: boolean, id: number }[] = [];

                                attRes.productAttachments.forEach(item => {
                                    item?.attachments.forEach(attachment => {
                                        allImages.push({ imgKey: attachment?.fileUrl, uploadCompleted: true, uploadLoader: false, id: attachment?.id });
                                    })
                                });
                                setMultipleImages(allImages);
                            }
                        }

                        //Variants
                        let allVals: { id: number, label: string }[][] = []
                        multiTextArray = []
                        if (res?.productDetails?.isVariants) {
                            let selVariants: number[] = []
                            res?.productDetails?.productOptionMappings.map((varId) => {
                                fetchedOpt.map((opt) => {
                                    if (opt.id == varId.optionId) {
                                        selVariants.push(opt?.id)
                                        multiTextArray.push(opt?.name)
                                    }
                                })
                            })

                            selVariants?.sort((a, b) => a - b)?.map((svar) => {
                                fetchedOpt.map((rvar) => {
                                    if (svar == rvar.id) {
                                        const tempVals = rvar.optionValues.map((val) => ({ "id": val.id, "label": val.optionValue }))
                                        allVals.push(tempVals)
                                    }
                                })
                            })

                            setMultiVariants(multiTextArray)
                            setSelectedVar(selVariants)
                            let combnObj: variantValue = {}
                            let selectedComb: string[] = []
                            let locArr: {
                                id: number,
                                stock: string,
                                threshold: string,
                                selectedLoc: number,
                                isInfinite: boolean,
                            }[] = []
                            res?.productDetails?.variantCombinationDetails.map(async (combn) => {
                                let selVals: number[] = []

                                let varIds = [...allVals]?.flat()?.map(i => i?.id)
                                combn.productVariantMappings.map((valObj) => {
                                    selVals.push(valObj.optionValueId)
                                })

                                if (selVals?.every(i => varIds?.includes(i))) {
                                    // For Attachment
                                    const foundAttachment = attRes?.productAttachments?.find(i => i?.itemId == combn?.id)
                                    if (attRes && attRes.productAttachments?.length > 0 && foundAttachment) {
                                        multi = []
                                        multi = await Promise.all(
                                            foundAttachment.attachments.map(async (val, i) => {
                                                return { imgKey: val.fileUrl, "uploadCompleted": true, "uploadLoader": false, id: val.id };
                                            })
                                        )

                                    }
                                    // location
                                    combn.multiLocationVariantStocks.map(async (loc) => {
                                        locArr.push({
                                            id: loc?.id,
                                            stock: JSON.stringify(loc?.stock),
                                            threshold: loc?.lowStockThresholdValue ? JSON.stringify(loc?.lowStockThresholdValue) : "",
                                            selectedLoc: loc?.inventoryLocationId!,
                                            isInfinite: (loc?.stock == -1) ? true : false,
                                        })
                                    })
                                    combnObj[combn.variantName] = {
                                        isDefault: combn?.isDefault,
                                        isSellOnline: false,
                                        isSellPos: combn?.isPos!,
                                        removedVariantImagesUrl: [],
                                        vid: combn?.id,
                                        locArr: locArr,
                                        weightOpen: false,
                                        dimensionOpen: false,
                                        selectedWunit: res?.productDetails?.weightUnitId ? String(res?.productDetails?.weightUnitId) : "",
                                        selectedDunit: combn?.measurementUnitId ? String(combn?.measurementUnitId) : "",
                                        width: combn?.width ? String(combn?.width) : '',
                                        weight: combn?.weight ? String(combn?.weight) : '',
                                        height: combn?.height ? String(combn?.height) : '',
                                        length: combn?.length ? String(combn?.length) : '',
                                        SKU: combn?.sku ? combn?.sku : '',
                                        UPC: combn?.upc ? combn?.upc : '',
                                        taxCode: combn?.taxCode ? combn?.taxCode : '',
                                        sellingPrice: combn?.price ? combn?.price : '',
                                        MRP: combn?.costComparePrice ? combn?.costComparePrice : '',
                                        SquareId: combn?.squarePosUuid ? combn?.squarePosUuid : '',
                                        WholesalePrice: combn?.wholeSalePrice ? combn?.wholeSalePrice : '',
                                        costPrice: combn?.cost ? combn?.cost : '',
                                        CustomLabel: combn?.customLabel ? combn?.customLabel : '',
                                        weightCount: combn?.weightCount ? combn?.weightCount : '',
                                        valueId: selVals,
                                        varImages: multi,
                                        variantAvailability: combn?.variantAvailability
                                    }
                                    locArr = []
                                    selectedComb.push(combn.variantName)
                                }
                            })
                            setVariantCombinations(combnObj)

                            let varCombns = getCombn(allVals)
                            let combo: { [Key: string]: { id?: string, checked?: boolean } }[] = []
                            let temp: { [Key: string]: { id?: string, checked?: boolean } } = {}
                            let found = false
                            varCombns?.map((item) => {
                                found = false
                                selectedComb.map((comb) => {
                                    if (comb?.split(',')?.sort()?.join(',') == item.label?.split(',')?.sort()?.join(',')) {
                                        temp[item.label] = { id: item.id as string, checked: true }
                                        found = true
                                    }
                                })
                                if (!found) {
                                    temp[item.label] = { id: item.id as string, checked: false }
                                }
                                combo.push(temp)
                                temp = {}
                            })

                            setChecked(combo)
                        }
                        setIsLoad(false)

                    }).catch((err) => {
                        ZenToast({ message: 'Failed to fetch details', type: "error" })
                        console.log('Failed to get attachment', err);
                    })
            }).catch((err) => {
                console.log('err in get product details', err)
                if (err && err.response && err.response.data) {
                    ZenToast({ message: err.response.data, type: "error" })
                } else if (err && err.message) {
                    ZenToast({ message: 'Failed to fetch details', type: "error" })
                }
            })
    }

    //Function used to update the product
    const handleEditProduct = (values: FormikValues) => {
        setSaveLoad(true)
        let variants: productPayload['variants']['variants'] = []
        let locationWiseStock: locationValue[] = []
        let productTaxMappings: { id?: null | number, taxCategoryId?: number, isEnabled?: boolean, isEnabledAllProducts?: null | boolean }[] = []
        let varImagesArr: { id?: number, ext?: string | null, fileData?: string, fileName?: string, image?: string, isImageStore?: boolean, sortOrder?: number }[] = []
        let mainImg: { fileName?: string, image?: string, isImageStore?: boolean }[] = [...delMain]
        let multiImg: { id?: number, fileName?: string, image?: string, isImageStore?: boolean, sortOrder?: number }[] = []

        //Image
        if (formik?.values?.featuredImage?.edit) {
            mainImg.push({
                "image": formik?.values?.featuredImage?.imgKey,
                "fileName": formik?.values?.featuredImage?.imgKey?.split('/').pop()
            })
        } else {
            let temp: { fileName?: string, image?: string, isImageStore?: boolean } = {}
            temp.fileName = formik?.values?.featuredImage?.imgKey?.split('/').pop()
            temp.image = formik?.values?.featuredImage?.imgKey
            temp.isImageStore = true
            mainImg.push(temp)
        }

        formik?.values?.additionalImages?.map((additionalImage, index) => {
            if (additionalImage?.id) {
                multiImg.push({
                    "id": additionalImage.id,
                    "image": additionalImage.imgKey,
                    "sortOrder": index + 1
                })
            } else {
                let temp: { fileName?: string, image?: string, isImageStore?: boolean, sortOrder?: number } = {}
                temp.fileName = additionalImage.imgKey?.split(".com/")[1]
                temp.image = additionalImage.imgKey
                temp.isImageStore = true
                temp.sortOrder = index + 1
                multiImg.push(temp)
            }
        })

        //Update variant array depending upon multi/single
        if (values.isMultiVariants) {
            Object.keys(formik?.values?.varCombinations).map((item, index) => {
                varImagesArr = []
                if (formik?.values?.varCombinations[item]?.varImages?.length != 0) {
                    formik?.values?.varCombinations[item]?.varImages?.map((varImg, index) => {
                        if (varImg.id != null) {
                            varImagesArr.push({
                                "id": varImg?.id,
                                "fileData": varImg?.imgKey,
                                "ext": getFileExtension(varImg?.imgKey),
                                "fileName": varImg?.imgKey?.split('/').pop(),
                                "sortOrder": index + 1
                            })
                        } else if (varImg?.imgKey) {
                            let temp: { fileName?: string, image?: string, isImageStore?: boolean, sortOrder?: number } = {}
                            temp.fileName = varImg?.imgKey?.split('/').pop()
                            temp.image = varImg?.imgKey
                            temp.isImageStore = true
                            temp.sortOrder = index + 1
                            varImagesArr.push(temp)
                        }
                    })
                }

                formik?.values?.varCombinations[item]?.locArr?.map((loc) => {
                    locationWiseStock.push({
                        "id": loc.id,
                        "storeId": storeId,
                        "inventoryLocationId": loc.selectedLoc,
                        "stockLimit": (loc.stock == "-1") ? 2 : 1,
                        "lowStockThresholdValue": (loc.threshold == "-1") ? null : (loc.threshold ? loc.threshold : null),
                        "stock": loc.stock,
                    })
                })
                variants.push({
                    "variantAttachments": varImagesArr,
                    "removedVariantImagesUrl": values?.varCombinations[item]?.removedVariantImagesUrl,
                    "optionValuesId": formik?.values?.varCombinations[item]?.valueId,
                    "variantName": item,
                    "variantCombinationData": {
                        "variantName": item,
                        "combinationName": formik?.values?.varCombinations[item].valueId?.sort().toString(),
                        "skuId": formik?.values?.varCombinations[item].vid ? String(formik?.values?.varCombinations[item].vid) : null,
                        "sku": formik?.values?.varCombinations[item].SKU ? formik?.values?.varCombinations[item].SKU : null,
                        "squarePosUuid": formik?.values?.varCombinations[item].SquareId ? formik?.values?.varCombinations[item].SquareId : null,
                        "customLabel": formik?.values?.varCombinations[item].CustomLabel ? formik?.values?.varCombinations[item].CustomLabel : values.ProductName + "-" + item,
                        "upc": formik?.values?.varCombinations[item].UPC ? formik?.values?.varCombinations[item].UPC : null,
                        "costComparePrice": formik?.values?.varCombinations[item].MRP ? formik?.values?.varCombinations[item].MRP : null,
                        "cost": formik?.values?.varCombinations[item].costPrice ? formik?.values?.varCombinations[item].costPrice : null,
                        "measurementUnitId": formik?.values?.varCombinations[item]?.selectedDunit.length != 0 ? parseInt(formik?.values?.varCombinations[item].selectedDunit as string) : null,
                        "weight": formik?.values?.varCombinations[item].weight ? formik?.values?.varCombinations[item].weight : null,
                        "weightCount": values.ProductUnitCount ? String(values.ProductUnitCount) : null,
                        "height": formik?.values?.varCombinations[item].height ? formik?.values?.varCombinations[item].height : null,
                        "width": formik?.values?.varCombinations[item].width ? formik?.values?.varCombinations[item].width : null,
                        "length": formik?.values?.varCombinations[item].length ? formik?.values?.varCombinations[item].length : null,
                        "price": formik?.values?.varCombinations[item].sellingPrice ? String(formik?.values?.varCombinations[item].sellingPrice) : null,
                        "wholeSalePrice": formik?.values?.varCombinations[item].WholesalePrice ? formik?.values?.varCombinations[item].WholesalePrice : null,
                        "locationWiseStock": locationWiseStock,
                        "isDefault": formik?.values?.varCombinations[item]?.isDefault,
                        "isPos": formik?.values?.varCombinations[item]?.isSellPos,
                        "variantAvailability": formik?.values?.varCombinations[item]?.variantAvailability,
                        "taxCode": formik?.values?.varCombinations[item]?.taxCode ? formik?.values?.varCombinations[item]?.taxCode : null
                    },
                })
                locationWiseStock = []
            })
        }
        else if (!values.isMultiVariants) {
            formik?.values?.locArr?.map((loc) => {
                locationWiseStock.push({
                    "id": loc?.id,
                    "storeId": storeId,
                    "inventoryLocationId": loc.selectedLoc,
                    "stockLimit": (loc.stock == "-1") ? 2 : 1,
                    "lowStockThresholdValue": (loc.threshold == "-1") ? null : (loc.threshold ? loc.threshold : null),
                    "stock": loc.stock,
                })
            })
            variants.push({
                "variantName": values.ProductName ? values.ProductName : '',
                "removedVariantImagesUrl": values?.removedVariantImagesUrl,
                "variantCombinationData": {
                    "variantName": values.ProductName ? values.ProductName : '',
                    "combinationName": values.ProductName ? values.ProductName : '',
                    "customLabel": values.ProductName ? values.ProductName : '',
                    "variantAvailability": true,
                    "skuId": formik?.values?.varCombinations[values?.ProductName]?.vid ? String(formik?.values?.varCombinations[values?.ProductName]?.vid) : null,
                    "sku": values.Sku ? values.Sku : null,
                    "squarePosUuid": values.square ? values.square : null,
                    "upc": values.Upc ? values.Upc : null,
                    "costComparePrice": values.MRP ? values.MRP : null,
                    "cost": values.costPrice ? values.costPrice : null,
                    "measurementUnitId": formik?.values?.varCombinations[values.ProductName]?.selectedDunit?.length != 0 ? parseInt(formik?.values?.varCombinations[values.ProductName]?.selectedDunit as string) : null,
                    "weight": formik?.values?.varCombinations[values.ProductName]?.weight ? formik?.values?.varCombinations[values.ProductName].weight : null,
                    "weightCount": values.ProductUnitCount ? String(values.ProductUnitCount) : null,
                    "height": formik?.values?.varCombinations[values.ProductName]?.height ? formik?.values?.varCombinations[values.ProductName].height : null,
                    "width": formik?.values?.varCombinations[values.ProductName]?.width ? formik?.values?.varCombinations[values.ProductName].width : null,
                    "length": formik?.values?.varCombinations[values.ProductName]?.length ? formik?.values?.varCombinations[values.ProductName]?.length : null,
                    "price": values.sellingPrice ? String(values.sellingPrice) : null,
                    "wholeSalePrice": values.WholesalePrice ? values.WholesalePrice : null,
                    "locationWiseStock": locationWiseStock,
                    "isDefault": true,
                    "isPos": values?.sellPos,
                    "taxCode": values?.taxCode ? values?.taxCode : null
                },
            })
            locationWiseStock = []
        }

        //Update Tax options selected
        formik.values.taxClasses.map((id) => {
            if (!productTaxMappings.find(item => item.taxCategoryId === id)) {
                productTaxMappings.push(
                    {
                        "id": null,
                        "taxCategoryId": id,
                        "isEnabled": true,
                        "isEnabledAllProducts": null
                    }
                )
            }
        })

        let found = false
        defaultTax.map((tax) => {
            found = false
            productTaxMappings.map((item, index) => {
                if (item.taxCategoryId == tax) {
                    found = true
                    if (!initDis.find(item => item == tax)) {
                        productTaxMappings.splice(index, 1)
                    }
                }
            })
            if (!found) {
                if (!productTaxMappings.find(item => item.taxCategoryId === tax)) {
                    productTaxMappings.push(
                        {
                            "id": null,
                            "taxCategoryId": tax,
                            "isEnabled": false,
                            "isEnabledAllProducts": null
                        }
                    )
                }
            }
        })
        initDis.map((tax) => {
            found = false
            productTaxMappings.map((item, index) => {
                if (item.taxCategoryId == tax) {
                    found = true
                }
            })
            if (!found) {
                if (!productTaxMappings.find(item => item.taxCategoryId === tax)) {
                    productTaxMappings.push(
                        {
                            "id": null,
                            "taxCategoryId": tax,
                            "isEnabled": false,
                            "isEnabledAllProducts": null
                        }
                    )
                }
            }
        })
        taxClassOptions.map((tax) => {
            productTaxMappings.map((item) => {
                if (tax.value == item.taxCategoryId) {
                    if (tax.isEnabledAllProducts) {
                        item.isEnabledAllProducts = true
                    }
                }
            })
        })

        //Final request parameter
        const data: productPayload = {
            productId: productId,
            general: {
                attachments: [
                    {
                        name: "Main Images",
                        attachmentData: mainImg
                    },
                    {
                        name: "Multiple Images",
                        attachmentCategoriesName: "Products",
                        attachmentData: multiImg
                    },
                    {
                        name: "",
                        attachmentData: []
                    }
                ],
                name: values.ProductName,
                "medium": "POS",
                shortDescription: values.ShortDescription ? values.ShortDescription : null,
                brandId: formik?.values.brand,
                orderQuantityMaximum: null,
                orderQuantityMinimum: null,
                productAvailability: values.isAvailable,
                weightCount: values.ProductUnitCount ? values.ProductUnitCount : null,
                weightUnitId: formik.values.weightUnit ? parseInt(formik.values.weightUnit as string) : null,
                isReturnable: values.isReturnable,
                relatedCategoryId: formik.values.categories ? formik.values.categories : [],
                description: null,
                isVariants: values.isMultiVariants ? values.isMultiVariants : false,
                isVeg: (values.productType == "Vegetarian")
                    ? true
                    : (values.productType == "Non Vegetarian" ? false : null),
                shipsByItself: null,
                hasModifiers: formik.values.modifierOption?.length > 0 ? true : (modUpdate.length > 0 ? true : false),
                ...(formik.values.isTaxable) && {
                    taxCategoryId: (formik.values.taxClasses?.length != 0) ? formik.values.taxClasses : null
                },
                variantCombinationDetailsId: rvarIds?.length != 0 ? rvarIds : [],
            } as productPayload['general'],
            isTaxable: (formik.values.isTaxable) ? true : false,
            productTaxMappings:
                (formik.values.isTaxable && productTaxMappings.length > 0)
                    ? productTaxMappings
                    : [],
            variants: {
                storeId: storeId,
                removedVariantIds: removeVarId,
                optionIds: (values.isMultiVariants) ? formik.values.selectedVariants : null,
                variants: variants,
                modifierIds: formik.values.modifierIds?.length > 0 ? formik.values.modifierIds : modIdUpdate,
                modifierOption: formik.values.modifierOption?.length > 0 ? formik.values.modifierOption : modUpdate
            },
        };
        console.log(JSON.stringify(data, undefined, 4));

        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        dispatch(updateProductCatalog({ data: formData, productId: Number(productId), storeId: config.storeId })).unwrap().then((res) => {
            if (res?.success) {
                setSaveLoad(false)
                ZenToast({ message: "Product updated successfully", type: "success" })
                navigation.goBack()
            }
        }).catch((err) => {
            setSaveLoad(false)
            ZenToast({ message: err?.response?.isOptionDeleted ? 'The selected variant combination does not exist, Kindly try again.' : "Error in updating product", type: "error" })
            console.log('Error in update product', err?.response)
        })
    }

    //Function used to handle confirmations
    const confirmation = (value: { id: number, name: string }) => {
        if (isLeavePopover && value?.name === 'Stay') {
            setIsLeavePopover(false)
        }
        else if (isLeavePopover && value?.name === 'Leave Page') {
            navigation.goBack()
            setIsLeavePopover(false)

        }
    }

    //UseEffect to be executed initially
    useEffect(() => {
        if (isFocused) {
            fetchOptions()
        }
    }, [isFocused])

    const handleBackPress = () => {
        if (formik?.dirty) {
            setIsLeavePopover(true)
        }
        else {
            navigation.goBack()
        }
    }

    //UseEffect function which is used to perform backhandler operation
    useEffect(() => {
        BackHandler.addEventListener('hardwareBackPress', function () {
            handleBackPress()
            return true
        })
    }, [formik?.dirty])

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <View style={theme?.addEditProductStyle?.containerView}>
                    <CommonHeader
                        backIcon
                        backIconOnpress={() => {
                            handleBackPress()
                        }}
                        headerName={productId ? (!isProductWrite ? 'View Product' : 'Edit Product') : 'Add Product'}
                        rightComponent={
                            isProductWrite ?
                                <View style={theme?.addEditProductStyle?.headerView}>
                                    {/* <ZenButton
                                        title="Cancel"
                                        containerStyle={theme?.addEditProductStyle?.buttonContainerStyle}
                                        buttonStyle={theme?.addEditProductStyle?.cancelButtonStyle}
                                        titleStyle={theme?.addEditProductStyle?.outlineButtonTitleStyle}
                                        onPress={() => {
                                            handleBackPress()
                                        }}
                                    /> */}
                                    <ZenButton
                                        title={productId ? "Update" : "Save"}
                                        // disabled={
                                        //     ([...((formik?.values?.additionalImages?.length) ? formik?.values?.additionalImages : [])]?.filter(i => i?.uploadCompleted == false)?.length > 0) || imgUploading || modValidation || !formik?.isValid ||
                                        //     (formik?.values.isMultiVariants && Object.keys(formik?.values?.varCombinations).length == 0) || isDuplicateValue || (!formik?.values.isMultiVariants && isDuplicateSku)
                                        //     || saveLoad || (productId && !(formik?.dirty)) || dupLoader?.productName || dupLoader?.sku
                                        // }
                                        containerStyle={theme?.addEditProductStyle?.buttonContainerStyle}
                                        buttonStyle={theme?.addEditProductStyle?.saveButtonStyle}
                                        titleStyle={theme?.addEditProductStyle?.buttonTitleStyle}
                                        onPress={() => {
                                            formik.handleSubmit()
                                        }}
                                    />
                                </View> : undefined
                        }
                    />

                    {
                        isLoad ? (
                            <ZenLoader
                                viewStyle={theme?.addEditProductStyle?.transparentView}
                                color={appColors?.primary}
                                lottieType="Local"
                                lottie={require('../../../../assets/infinityLoader.json')}
                            />
                        ) : (
                            // tab details
                            <TopTab.Navigator
                                initialRouteName="General"
                                screenOptions={{
                                    tabBarLabelStyle: {
                                        fontSize: fontSize.largerFontSize,
                                        fontFamily: appFonts.bold,
                                        textTransform: 'capitalize',
                                    },
                                    tabBarIndicatorStyle: { backgroundColor: appColors.primary },
                                    tabBarActiveTintColor: appColors.primary,
                                    tabBarInactiveTintColor: appColors.lightFontColor,
                                    tabBarAndroidRipple: { borderless: false },
                                    animationEnabled: false
                                }}
                                backBehavior="none">
                                {/* general details */}
                                <TopTab.Screen
                                    name="General"
                                    options={{ tabBarLabel: 'General' }}
                                    children={() => (
                                        <ProductGeneral
                                            setDelMain={setDelMain}
                                            multiCategory={multiCategory!}
                                            setMultiCategory={setMultiCategory}
                                            formik={formik}
                                            singleVid={singleVid}
                                            isProductWrite={isProductWrite}
                                            setDupLoader={setDupLoader}
                                            productId={productId}
                                            isDuplicateSku={isDuplicateSku}
                                            setIsDuplicateSku={setIsDuplicateSku}
                                            isDuplicateValue={isDuplicateValue}
                                            setIsDuplicateValue={setIsDuplicateValue}
                                            dimensionOptions={dimensionOptions}
                                            categoryOptions={categoryOptions}
                                            multiTextArray={multiTextArray}
                                            weightOptions={weightOptions}
                                            brandOptions={brandOptions}
                                            imgUploading={imgUploading}
                                            setImgUploading={setImgUploading}
                                            setTaxCopy={setTaxCopy}
                                            taxCopy={taxCopy}
                                            defaultTax={defaultTax}
                                            taxClassOptions={taxClassOptions}
                                            multiTax={multiTax}
                                            setMultiTax={setMultiTax}
                                            setChecked={setChecked}
                                            rvarIds={rvarIds}
                                            setRvarIds={setRvarIds}
                                            setSelectedVarObj={setSelectedVarObj}
                                            locationOptions={locationOptions}
                                            multipleImages={multipleImages}
                                            setMainImage={setMainImage}
                                        />
                                    )} />
                                {/* variant details */}
                                <TopTab.Screen
                                    name="Variant"
                                    options={{ tabBarLabel: 'Variant' }}
                                    children={() =>
                                        <ProductVariant
                                            getCombn={getCombn}
                                            varRes={varRes}
                                            imgUploading={imgUploading}
                                            setImgUploading={setImgUploading}
                                            formik={formik}
                                            multiVariants={multiVariants}
                                            setMultiVariants={setMultiVariants}
                                            variants={variants}
                                            selectedVarObj={selectedVarObj}
                                            setSelectedVarObj={setSelectedVarObj}
                                            multiTextArray={multiTextArray}
                                            checked={checked}
                                            setChecked={setChecked}
                                            dimensionOptions={dimensionOptions}
                                            categoryOptions={categoryOptions}
                                            brandOptions={brandOptions}
                                            locationOptions={locationOptions}
                                            productId={productId}
                                            defLoc={defLoc!}
                                            isProductWrite={isProductWrite}
                                            setRemoveVarId={setRemoveVarId}
                                        />}
                                >
                                </TopTab.Screen>
                                {/* modifier details */}
                                <TopTab.Screen
                                    name="Modifier"
                                    options={{ tabBarLabel: 'Modifier' }}
                                    children={() => (
                                        <ProductModifier
                                            selectedModOptObj={selectedModOptObj}
                                            setSelectedModOptObj={setSelectedModOptObj}
                                            modiferDropdownData={modiferDropdownData}
                                            formik={formik}
                                            setModValidation={setModValidation}
                                            editMod={editMod}
                                            setEditMod={setEditMod}
                                            optionsMod={optionsMod}
                                            setOptionsMod={setOptionsMod}
                                            isProductWrite={isProductWrite}
                                            modUpdate={modUpdate}
                                            setModUpdate={setModUpdate}
                                            multiOptions={multiOptions}
                                            setMultiOptions={setMultiOptions}
                                        />
                                    )}></TopTab.Screen>
                            </TopTab.Navigator>
                        )
                    }
                    {/* Dirty Popover */}
                    <Popover
                        isVisible={isLeavePopover}
                        popoverStyle={[
                            theme?.addEditProductStyle?.popoverStyle,
                            {
                                width: width > 900 ? 600 : width > 600 ? 500 : 300,
                            }
                        ]}>
                        <CommonDialogBox
                            type='EDIT'
                            replaceValue="page"
                            confirmation={confirmation}
                        />
                    </Popover>
                    <CustomModal visible={saveLoad} transparent>
                        <ZenLoader
                            viewStyle={theme?.addEditProductStyle?.transparentView}
                            color={appColors?.primary}
                            lottieType="Local"
                            lottie={require('../../../../assets/infinityLoader.json')}
                        />
                    </CustomModal>
                </View>

            )}
        </ThemeConsumer>
    )
}

export default AddEditProduct